import { If } from "./control-statements";
import styles from "../../styles/badge.module.css";

const st = (className) => styles[className];

export const Badge = ({
  name,
  type = "neutral",
  absolute = true,
  icon,
  className,
}) => {
  return (
    <div
      className={`${st("badge")} ${st(type)} ${
        absolute ? st("absolute") : ""
      } ${className}`}
    >
      <If cond={icon}>
        <div>{icon}</div>
      </If>
      {name}
    </div>
  );
};
